export default __webpack_public_path__ + "static/media/Spotify_Icon_RGB_Black.0e932c0a.png";